// extracted by mini-css-extract-plugin
export var eyebrow = "PageHeading-module--eyebrow--gLPj-";
export var root = "PageHeading-module--root--YZBG8";
export var title = "PageHeading-module--title--t1DHw";